"use client";

import { useLocale } from "next-intl";
import { useLayoutEffect } from "react";
import { useEnabledThemes } from "@/components/brand-provider/app-brand-provider";
import { DEFAULT_THEME } from "../default-theme";
import { effectiveTheme } from "../effective-theme";
import { applyToDocument } from "./client";
import { useThemeSettings } from "./use-theme-settings";

/** Re-applies the saved theme and mode before paint whenever the language changes, because switching language swaps <html> and drops them. A saved theme that is switched off shows the default theme; the saved value is left as it is. */
export function ThemeRestorer() {
  const locale = useLocale();
  const enabled = useEnabledThemes();
  const { theme, mode } = useThemeSettings();
  useLayoutEffect(() => {
    applyToDocument(effectiveTheme(theme, enabled, DEFAULT_THEME), mode);
  }, [locale, theme, mode, enabled]);
  return null;
}
